<div
  class="palantir-progress-bar__container"
  [class.palantir-progress-bar__container--draggable]="mode === 'draggable'"
  (pointerdown)="onDragStart($event)"
>
  <div
    class="palantir-progress-bar"
    [class.palantir-progress-bar--indeterminate]="mode === 'indeterminate'"
    [style.width]="_progress() + '%'"
  ></div>

  @if (mode === 'draggable') {
    <div
      class="palantir-progress-bar__thumb"
      [style.left]="_progress() + '%'"
      (pointerdown)="onDragStart($event)"
    ></div>
  }
</div>
